import { money } from "@/lib/api";

export const CommissionFlag = ({ r }) => (r.commission_ok === false ? (
  <span className="ml-1 inline-block rounded bg-amber-50 px-1.5 py-0.5 text-[10px] font-medium text-amber-800 ring-1 ring-amber-200"
    title={`Commission retenue ${money(r.commission)} au lieu de ${money(r.commission_attendue)} (règle : ${r.commission_regle})`}
    data-testid={`commission-flag-${r.id}`}>
    Commission {Number(r.commission_taux).toFixed(1).replace(".", ",")} % ≠ {r.commission_regle}
  </span>
) : null);
